// extracted by mini-css-extract-plugin
module.exports = {"articleContent":"Actualites_articleContent__1WSlA","articleDate":"Actualites_articleDate__3-ORW","tagSelect":"Actualites_tagSelect__u7n6D"};